import { createContext, useCallback, useContext, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import AppLoadingOverlay from "../components/ui/AppLoadingOverlay";

const AppLoadingContext = createContext(null);

export function AppLoadingProvider({ children }) {
  const [state, setState] = useState({
    count: 0,
    title: "Loading…",
    subtitle: "",
    loaderStyle: "dots",
    bg: undefined,
    hideContent: false,
  });

  const showOverlay = useCallback((cfg = {}) => {
    setState((s) => ({ ...s, ...cfg, count: s.count + 1 }));
  }, []);

  const hideOverlay = useCallback(() => {
    setState((s) => {
      const next = Math.max(0, s.count - 1);
      return {
        ...s,
        count: next,
        bg: next === 0 ? undefined : s.bg,
        hideContent: next === 0 ? false : s.hideContent,
      };
    });
  }, []);

  return (
    <AppLoadingContext.Provider value={{ showOverlay, hideOverlay }}>
      {children}
      <AnimatePresence>
        {state.count > 0 && (
          <motion.div
            key="global-overlay"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <AppLoadingOverlay
              title={state.title}
              subtitle={state.subtitle}
              loaderStyle={state.loaderStyle}
              bg={state.bg}
              hideContent={state.hideContent}
              visible
            />
          </motion.div>
        )}
      </AnimatePresence>
    </AppLoadingContext.Provider>
  );
}

export function useAppLoading() {
  return useContext(AppLoadingContext);
}
